<template>
  <Header_en_m></Header_en_m>
  <div @wheel.prevent="slide">
    <Index_index_en_m></Index_index_en_m>
    <Index_concept_en_m></Index_concept_en_m>
    <Index_team_en_m></Index_team_en_m>
    <Index_enterprise_en_m></Index_enterprise_en_m>
    <Index_news_en_m></Index_news_en_m>
    <Index_contact_en_m></Index_contact_en_m>
    <Index_affix_en_m></Index_affix_en_m>
    <router-view/>
  </div>
</template>

<script>
import {reactive, onMounted} from 'vue'
import Index_index_en_m from "@/components/EN_mobile/index/Index_index_en_m";
import Index_concept_en_m from "@/components/EN_mobile/index/Index_concept_en_m";
import Index_team_en_m from "@/components/EN_mobile/index/Index_team_en_m";
import Index_enterprise_en_m from "@/components/EN_mobile/index/Index_enterprise_en_m";
import Index_news_en_m from "@/components/EN_mobile/index/Index_news_en_m";
import Index_contact_en_m from "@/components/EN_mobile/index/Index_contact_en_m";
import Index_affix_en_m from "@/components/EN_mobile/index/Index_affix_en_m";
import Header_en_m from "@/components/EN_mobile/Header_en_m";
export default {
  name: 'Index_en_m',
  components: {
    Header_en_m,
    Index_affix_en_m,
    Index_contact_en_m,
    Index_news_en_m,
    Index_enterprise_en_m,
    Index_team_en_m,
    Index_concept_en_m,
    Index_index_en_m,

  },

  setup() {
    let time = reactive({
      prev: Date.now(),
      now: Date.now(),
      delay: 1000,
    })
    const slide = () => {
      time.now = Date.now()
      if (time.now - time.prev > time.delay) {
        if (window.event.deltaY > 0) {
          document.documentElement.scrollBy({
            top: window.innerHeight,
            behavior: "smooth",
          })
        } else {
          document.documentElement.scrollBy({
            top: -window.innerHeight,
            behavior: "smooth",
          })
        }
        time.prev = Date.now()
      }
    }
    onMounted(() => {
    })
    return {slide}
  }
}
</script>
<style>
::-webkit-scrollbar {
  display: none
}
</style>

